<template>
    <div class="float-left mr-1">
        <b-button
            variant="primary"
            @click.stop="abrirModalAtualizarSubItem()"
            :disabled="itensSelecionados.length === 0"
        >
            <i class="fa fa-edit mr-2"></i> Atualizar Valores em Lote -
            <b-badge variant="light" :style="{ position: 'static' }">{{
                itensSelecionados.length
            }}</b-badge>
        </b-button>
        <b-modal
            id="modalAtualizarSubItem"
            v-model="mostrarModalAtualizarSubItem"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                SubItem do Contrato -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
             <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O quê deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group v-model="contratoApostilamento"  @change="alternaJustificativa($event)">
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo</label>
                        <b-form-select
                            :options="[
                                { value: 'P', text: 'PERCENTUAL' },
                                { value: 'V', text: 'VALOR' }
                            ]"
                            v-model="tipo"
                            text-field="text"
                            value-field="value"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Ação</label>
                        <b-form-select
                            :options="[
                                { value: 'A', text: 'ADIÇÃO' },
                                { value: 'S', text: 'SUBTRAÇÃO' }
                            ]"
                            v-model="acao"
                            text-field="text"
                            value-field="value"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        :invalid-feedback="`${titulo} é obrigatório`"
                    >
                        <label>{{ titulo }}</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{textoInfoJustificativa}} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalAtualizarSubItem()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarSubItem()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        itensSelecionados: {
            type: Array,
            default: () => []
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        },

        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalAtualizarSubItem: false,
            obterSubItensAtualizados: false,
            operacao: 'ATUALIZAÇÃO DOS VALORES EM LOTE',
            erros: [],
            titulo: 'Percentual',
            valor: 0,
            tipo: 'P',
            acao: 'A',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        abrirModalAtualizarSubItem() {
            this.mostrarModalAtualizarSubItem = true
        },

        fecharModalAtualizarSubItem() {
            this.mostrarModalAtualizarSubItem = false
            this.resetAtualizarSubItem()
            if (this.obterSubItensAtualizados) {
                this.$emit('obterSubItensAtualizados')
                this.$emit('limparItensSelecionados')
            }
        },

        resetAtualizarSubItem() {
            this.justificativaApostilamento = ''
            this.valor = 0
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {},

        confirmarSalvarSubItem() {
            this.$swal({
                title: 'SubItens do Contrato',
                html: `Confirma a atualização dos valores em lote?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarSubItem()
                }
            })
        },

        salvarSubItem() {
            this.$store.dispatch('addRequest')
            let subItensAtualizadosDto = {
                idContrato: this.contrato.idContrato,
                itensContratoId: this.itensSelecionados,
                valor: this.valor,
                tipo: this.tipo,
                acao: this.acao,
                justificativaApostilamento: this.justificativaApostilamento,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.atualizarValoresEmLoteItemContrato(
                subItensAtualizadosDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterSubItensAtualizados = true
                        this.fecharModalAtualizarSubItem()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        atualizacaoContrato() {
            return (this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido())
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if(this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if((this.apostilamento || this.atualizacaoContrato()) && this.contratoApostilamento != null) {
                return true
            } else if(this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if(this.$temAcessoView('CONT-ATUALIZAR-00') && this.$temAcessoView('CONT-APOST-04')) {
                this.contratoApostilamento = null
            } else if(this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if(this.$temAcessoView('CONT-APOST-04')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        },

    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        mostrarCheckApostilamento() {
            return (
                this.atualizacaoContrato()  && this.apostilamento
            )
        },
    },

    watch: {
        tipo() {
            if (this.tipo === 'P') {
                this.money.prefix = ''
                this.titulo = 'Percentual'
            } else {
                this.money.prefix = 'R$ '
                this.titulo = 'Valor'
            }
        }
    },

    validations: {
        valor: {
            required,
            minValue: minValue(0.01)
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}
</script>
